/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactModel } from '../../models/client-survey-contact-model';
import { UpdateSurveyContactRequest } from '../../models/update-survey-contact-request';

export interface UpdateSurveyContactAsync$Plain$Params {
  surveyContactId: string;
  
    /**
     * update request variables
     */
    body?: UpdateSurveyContactRequest
}

export function updateSurveyContactAsync$Plain(http: HttpClient, rootUrl: string, params: UpdateSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
  const rb = new RequestBuilder(rootUrl, updateSurveyContactAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('surveyContactId', params.surveyContactId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactModel>;
    })
  );
}

updateSurveyContactAsync$Plain.PATH = '/api/SurveyContact/{surveyContactId}';
